import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_5 = {
  key: 0,
  class: "field"
}
const _hoisted_6 = { class: "control" }
const _hoisted_7 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_8 = {
  key: 1,
  class: "field"
}
const _hoisted_9 = { class: "control" }
const _hoisted_10 = {
  key: 1,
  disabled: "",
  class: "button is-success"
}
const _hoisted_11 = { class: "field" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_15 = {
  key: 2,
  class: "select is-fullwidth"
}
const _hoisted_16 = { disabled: "" }
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "control" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "control" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "control" }
const _hoisted_23 = { class: "field" }
const _hoisted_24 = { class: "control" }
const _hoisted_25 = {
  key: 2,
  class: "field"
}
const _hoisted_26 = { class: "control" }
const _hoisted_27 = ["placeholder", "disabled"]
const _hoisted_28 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_29 = {
  key: 3,
  class: "field"
}
const _hoisted_30 = { class: "control" }
const _hoisted_31 = {
  key: 1,
  disabled: "",
  class: "button is-success"
}

import { required } from '@vuelidate/validators';
import Toast from '@/shared/services/toast';
import { InstallWhatsAppRequest } from './models';
import { WhatsAppApi, whatsAppApi } from './services/whatsappApi';
import { useStore } from 'vuex';
import { computed, onBeforeMount, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { useRouter } from 'vue-router';

interface PhoneNumberSelectOption {
  id: string;
  label: string;
}

enum SecretValidity {
  Invalid = 0,
  Validating = 1,
  Valid = 2,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'whatsappConfig',
  emits: ["loaded", "configSaved"],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const currentApp = computed(() => store.getters.currentApp);

const businessAccountId = ref('');
const apiKey = ref('');
const appName = ref('');
const appId = ref('');
const appSecret = ref('');
const phoneNumbers = ref<PhoneNumberSelectOption[]>([]);
const selectedPhoneNumber = ref<PhoneNumberSelectOption | null>();
const apiKeyValid = ref(SecretValidity.Invalid);
const appSecretValid = ref(SecretValidity.Invalid);
const hasWhatsAppInstalledApp = ref(false);
const actionInProgress = ref(false);

const validations = {
  businessAccountId: { required },
  apiKey: { required },
  selectedPhoneNumber: { required },
  appSecret: { required },
};

const $v = useVuelidate(validations, { businessAccountId, apiKey, selectedPhoneNumber, appSecret });

const emit = __emit;

const api: WhatsAppApi = whatsAppApi;

onBeforeMount(() => {
  if (currentApp.value.isInstalled) {
    api
      .getInstalledApp(currentWorkspace.value.id)
      .then((response) => {
        if (response.installedApp) {
          hasWhatsAppInstalledApp.value = true;

          const app = response.installedApp;
          businessAccountId.value = app.businessAccountId;
          selectedPhoneNumber.value = { id: '0', label: app.phoneNumber };
          appName.value = app.appName;
          appId.value = app.appId;
        } else {
          hasWhatsAppInstalledApp.value = false;
        }
      })
      .catch((err) => {
        // if it's not found, then we haven't installed the WhatsApp app fully, so let them fill in the form
        hasWhatsAppInstalledApp.value = false;
        if (err.status !== 404) {
          // show error state...
        }
      })
      .finally(() => {
        emit('loaded');
      });
  } else {
    emit('loaded');
  }
});

function isSecretValid(state: SecretValidity) {
  return state === SecretValidity.Valid;
}

function isSecretValidating(state: SecretValidity) {
  return state === SecretValidity.Validating;
}

function invalidateBusinessAccountIdField() {
  $v.value.businessAccountId.$touch();
  invalidateApiKey();
}

function invalidateApiKeyField() {
  $v.value.apiKey.$touch();
  invalidateApiKey();
}

async function validateApiKey() {
  if (hasWhatsAppInstalledApp.value) {
    return;
  }

  if (businessAccountId.value && apiKey.value) {
    await getWhatsAppAccount();
  } else {
    phoneNumbers.value = [];
    selectedPhoneNumber.value = null;
  }
}

async function getWhatsAppAccount() {
  try {
    apiKeyValid.value = SecretValidity.Validating;
    const response = await api.getAccount(currentWorkspace.value.id, businessAccountId.value, apiKey.value);

    phoneNumbers.value = response.phoneNumbers.map((p) => ({ id: p.id, label: p.number }));

    if (phoneNumbers.value.length > 0) {
      if (!selectedPhoneNumber.value) {
        selectedPhoneNumber.value = phoneNumbers.value[0];
      }

      if (response.subscribedApp) {
        appId.value = response.subscribedApp.appId;
        appName.value = response.subscribedApp.name;
        apiKeyValid.value = SecretValidity.Valid;
        return;
      }
    }
  } catch (e: any) {
    apiKeyValid.value = SecretValidity.Invalid;
    phoneNumbers.value = [];
    selectedPhoneNumber.value = null;
    Toast.showError('Failed to verify API Key');
  }
}

function invalidateAppSecretField() {
  $v.value.appSecret.$touch();
  appSecretValid.value = SecretValidity.Invalid;
}

async function validateAppSecret() {
  if (hasWhatsAppInstalledApp.value) {
    return;
  }

  if (appId.value && appSecret.value) {
    await getAppSubscription();
  }
}

async function getAppSubscription() {
  try {
    appSecretValid.value = SecretValidity.Validating;
    await api.getSubscription(currentWorkspace.value.id, appId.value, appSecret.value);

    appSecretValid.value = SecretValidity.Valid; // doesn't return unauthorized, so we assume it's valid
  } catch (e: any) {
    appSecretValid.value = SecretValidity.Invalid;
    Toast.showError('Failed to verify App Secret');
  }
}

function save() {
  if (actionInProgress.value) {
    return;
  }

  actionInProgress.value = true;

  const request: InstallWhatsAppRequest = {
    installId: currentApp.value.installedAppId,
    workspaceId: currentWorkspace.value.id,
    businessAccountId: businessAccountId.value,
    apiKey: apiKey.value,
    phoneNumberId: selectedPhoneNumber.value!.id,
    phoneNumber: selectedPhoneNumber.value!.label,
    appName: appName.value,
    appId: appId.value,
    appSecret: appSecret.value,
  };

  api
    .install(request)
    .then(() => emit('configSaved'))
    .catch((err) => Toast.showError(err.message))
    .finally(() => (actionInProgress.value = false));
}

function cancel() {
  router.push({ name: 'apps' });
}

function invalidateApiKey() {
  apiKeyValid.value = SecretValidity.Invalid;
  appSecretValid.value = SecretValidity.Invalid;
  selectedPhoneNumber.value = null;
  appName.value = '';
  appId.value = '';
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("fieldset", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label" }, "Business Account ID", -1)),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["input", { 'is-danger': _unref($v).businessAccountId.$invalid && _unref($v).businessAccountId.$dirty }]),
          type: "text",
          placeholder: "Enter Business Account ID here",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((businessAccountId).value = $event)),
          onInput: _cache[1] || (_cache[1] = ($event: any) => (invalidateBusinessAccountIdField())),
          disabled: hasWhatsAppInstalledApp.value
        }, null, 42, _hoisted_3), [
          [
            _vModelText,
            businessAccountId.value,
            void 0,
            { trim: true }
          ]
        ]),
        (_unref($v).businessAccountId.$invalid && _unref($v).businessAccountId.$dirty)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " The Business Account ID is required "))
          : _createCommentVNode("", true)
      ])
    ]),
    (!hasWhatsAppInstalledApp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "API Key", -1)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input", { 'is-danger': _unref($v).apiKey.$invalid && _unref($v).apiKey.$dirty }]),
              type: "password",
              placeholder: "Enter API Key here",
              required: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((apiKey).value = $event)),
              onInput: _cache[3] || (_cache[3] = ($event: any) => (invalidateApiKeyField()))
            }, null, 34), [
              [
                _vModelText,
                apiKey.value,
                void 0,
                { trim: true }
              ]
            ]),
            (_unref($v).apiKey.$invalid && _unref($v).apiKey.$dirty)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "The API Key is required"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!hasWhatsAppInstalledApp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (!isSecretValid(apiKeyValid.value))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(["button is-link", { 'is-loading': isSecretValidating(apiKeyValid.value) }]),
                  onClick: validateApiKey
                }, "Validate", 2))
              : (_openBlock(), _createElementBlock("a", _hoisted_10, "Validated"))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Phone Number", -1)),
      (!hasWhatsAppInstalledApp.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["select is-fullwidth", { 'is-loading': isSecretValidating(apiKeyValid.value) }])
          }, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedPhoneNumber).value = $event)),
              disabled: !isSecretValid(apiKeyValid.value)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phoneNumbers.value, (number) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: number.id,
                  value: number
                }, _toDisplayString(number.label), 9, _hoisted_13))
              }), 128))
            ], 8, _hoisted_12), [
              [_vModelSelect, selectedPhoneNumber.value]
            ])
          ], 2))
        : _createCommentVNode("", true),
      (_unref($v).selectedPhoneNumber.$invalid && _unref($v).selectedPhoneNumber.$dirty)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, " The Phone Number is required "))
        : _createCommentVNode("", true),
      (hasWhatsAppInstalledApp.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("select", _hoisted_16, [
              _createElementVNode("option", null, _toDisplayString(selectedPhoneNumber.value?.label), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Subscribed App", -1)),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              disabled: "",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((appName).value = $event))
            }, null, 512), [
              [_vModelText, appName.value]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "App ID", -1)),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              disabled: "",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((appId).value = $event))
            }, null, 512), [
              [_vModelText, appId.value]
            ])
          ])
        ])
      ])
    ]),
    (!hasWhatsAppInstalledApp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "App Secret", -1)),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input", { 'is-danger': _unref($v).appSecret.$invalid && _unref($v).appSecret.$dirty }]),
              type: "password",
              placeholder: isSecretValid(apiKeyValid.value) ? 'Enter App Secret here' : '',
              required: "",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((appSecret).value = $event)),
              onInput: _cache[8] || (_cache[8] = ($event: any) => (invalidateAppSecretField())),
              disabled: !isSecretValid(apiKeyValid.value)
            }, null, 42, _hoisted_27), [
              [
                _vModelText,
                appSecret.value,
                void 0,
                { trim: true }
              ]
            ]),
            (_unref($v).appSecret.$invalid && _unref($v).appSecret.$dirty)
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, "The App Secret is required"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!hasWhatsAppInstalledApp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            (!isSecretValid(appSecretValid.value))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(["button is-link", { 'is-loading': isSecretValidating(appSecretValid.value) }]),
                  onClick: validateAppSecret
                }, "Validate", 2))
              : (_openBlock(), _createElementBlock("a", _hoisted_31, "Validated"))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_n_button_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_n_button, {
          variant: "primary",
          onClick: save,
          disabled: _unref($v).$invalid || !isSecretValid(apiKeyValid.value) || !isSecretValid(appSecretValid.value),
          loading: actionInProgress.value
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode("Submit")
          ])),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createVNode(_component_n_button, {
          onClick: cancel,
          variant: "primary--outline"
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode("Cancel")
          ])),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})